<div class="w-full h-full flex text-white">
  <div class="w-55 flex-1 flex flex-col items-center justify-center gap-8">
    <img class="w-55" alt="" src="assets/waiting-chat.svg" />
    <p class="text-center text-sm">The Chat is being processed and will be available shortly</p>
    <mib-dots-loader size="sm" color="light" label="Preparing the answer"></mib-dots-loader>
  </div>
</div>
